<template>
    <v-menu v-model="menu" offset-y left>
        <template #activator="{ on: menuOn, attrs: menuAttrs }">
            <button-tooltip bottom :tooltip="tooltip || $t('common.options')" :disabled="menu">
                <template #activator="{ on, attrs }">
                    <button type="button" class="actions-menu-btn" v-bind="{ ...attrs, ...menuAttrs }"
                        v-on="{ ...on, ...menuOn }">
                        <v-icon size="20">mdi-dots-vertical</v-icon>
                    </button>
                </template>
            </button-tooltip>
        </template>
        <v-list dense>
            <v-list-item v-for="item in items" :key="item.key" link @click="item.action()">
                <v-icon size="18" color="txtSecondary" class="mr-2">{{ item.icon }}</v-icon>
                <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import ButtonTooltip from '@/components/common/ButtonTooltip'

export default {
    name: 'ActionsMenu',
    components: { ButtonTooltip },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        tooltip: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            menu: false,
        }
    },
}
</script>

<style scoped>
.actions-menu-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    border: 1px solid var(--v-outline-base);
    background: var(--v-surface2-base);
    color: var(--v-txtSecondary-base);
}

.actions-menu-btn .v-icon {
    color: inherit !important;
}
</style>
